import React from 'react';
import './Home.css';

const Home: React.FC = () => {
  return (
    <section id="home" className="home">
      <div className="container">
        <div className="home-content">
          <div className="home-text">
            <h2 className="section-title">Bem-vindos à Garcias Milho</h2>
            <p className="section-subtitle">
              Vendas e distribuição de milho premium para supermercados, açougues, 
              sacolões, bares, restaurantes, clubes e outros estabelecimentos.
            </p>
            <div className="features">
              <div className="feature">
                <div className="feature-icon">🌽</div>
                <h3>Milho Premium</h3>
                <p>Grãos selecionados com qualidade superior e sabor marcante</p>
              </div>
              <div className="feature">
                <div className="feature-icon">✨</div>
                <h3>Qualidade Garantida</h3>
                <p>Processamento cuidadoso mantendo frescor e propriedades nutricionais</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🚚</div>
                <h3>Distribuição Eficiente</h3>
                <p>Entrega rápida e confiável para toda a região</p>
              </div>
            </div>
          </div>
          <div className="home-image">
            <img src="/images/produto-garcias-milho-2-kg.jpg" alt="Garcias Milho Premium" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
